import { useLingui } from '@lingui/react/macro';
import { BarChart } from '@repo/videa-components/src/common-charts/index';

import { chartColors } from '../../../../../packages/videa-components/src/common-charts/themes/colors';

interface Props {
  highlightPostAiValue?: number;
  highlightPreAiValue?: number;
}

export const AIImpactBarChart = ({
  highlightPostAiValue,
  highlightPreAiValue,
}: Props) => {
  const { t } = useLingui();

  if (!highlightPostAiValue || !highlightPreAiValue) {
    return null;
  }

  return (
    <BarChart
      chartOptions={{
        options: {
          chart: {
            type: 'bar',
            backgroundColor: 'transparent',
            height: 110,
            marginRight: 80,
            spacingBottom: 0,
            marginBottom: 40,
          },
          title: { text: undefined },
          xAxis: {
            labels: { enabled: false },
            lineWidth: 0,
            tickWidth: 0,
          },
          yAxis: { visible: false },
          series: [
            {
              name: t`Pre AI Average`,
              type: 'bar',
              data: [Math.round(highlightPreAiValue)],
              pointWidth: 12,
              color: '#A0A0A0',
              dataLabels: {
                useHTML: true,
                formatter: function (this: any) {
                  return `
                            <div style="display: flex; align-items: center;">
                              <span style="color: #18181B; font-size: 14px; font-weight: bold;">
                                $${this.y}
                              </span>
                              <span style="color: #18181B; font-size: 12px; font-weight: normal;">
                                /patient
                              </span>
                            </div>
                          `;
                },
              },
            },
            {
              name: t`Post AI Average`,
              type: 'bar',
              data: [Math.round(highlightPostAiValue)],
              pointWidth: 12,
              color: '#4C9E2E',
              dataLabels: {
                useHTML: true,
                formatter: function (this: any) {
                  return `
                            <div style="display: flex; align-items: center;">
                              <span style="color: ${chartColors.chart[3]}; font-size: 14px; font-weight: bold;">
                                $${this.y}
                              </span>
                              <span style="color: #18181B; font-size: 12px; font-weight: normal;">
                                /patient
                              </span>
                            </div>
                          `;
                },
              },
            },
          ],
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                align: 'left',
                inside: false,
                crop: false,
                overflow: 'allow',
              },
            },
            bar: { borderWidth: 0 },
          },
          legend: {
            enabled: true,
            symbolRadius: 4,
          },
          tooltip: { enabled: false },
        },
      }}
    />
  );
};
